import { render, staticRenderFns } from "./formStock.vue?vue&type=template&id=6d618a54&scoped=true"
import script from "./formStock.vue?vue&type=script&lang=js"
export * from "./formStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d618a54",
  null
  
)

export default component.exports